import { c as _c } from "react/compiler-runtime";
import { Button, Input } from '@common/components';
import { useClipboard } from '@common/hooks';
import { ResponsiveDialog } from '@/components/organism/ResponsiveDialog';
interface CouponDetailDrawerProps {
  opened: boolean;
  onClose: () => void;
  couponCode: string;
}
export const CouponDetailDrawer = t0 => {
  const $ = _c(14);
  const {
    opened,
    onClose,
    couponCode
  } = t0;
  const copy = useClipboard();
  let t1;
  if ($[0] !== copy || $[1] !== couponCode) {
    t1 = () => {
      copy({
        message: "PIN \uBC88\uD638\uB97C \uBCF5\uC0AC\uD588\uC5B4\uC694",
        value: couponCode
      });
    };
    $[0] = copy;
    $[1] = couponCode;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleCopy = t1;
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p className="pb-8 font-700 text-Gray-900 typo-body2 mobile-tablet:pb-8 mobile-tablet:font-700 mobile-tablet:typo-body1">모바일 교환권의 PIN 번호예요.</p>;
    t3 = <p className="pb-20 font-400 text-Gray-700 typo-body3 mobile-tablet:text-Gray-600 mobile-tablet:typo-body4">PIN 번호를 복사해 사용해주세요.</p>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== couponCode) {
    t4 = <Input value={couponCode} dimensions="H48" readOnly={true} />;
    $[5] = couponCode;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== handleCopy) {
    t5 = <Button theme="primary-fill" dimensions="H56" className="mt-24 w-full" onClick={handleCopy}>복사하기</Button>;
    $[7] = handleCopy;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== onClose || $[10] !== opened || $[11] !== t4 || $[12] !== t5) {
    t6 = <ResponsiveDialog opened={opened} onClose={onClose} drawerType="bottom">{t2}{t3}{t4}{t5}</ResponsiveDialog>;
    $[9] = onClose;
    $[10] = opened;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};